import { render, staticRenderFns } from "./no_permission.vue?vue&type=template&id=aedafab8&scoped=true"
import script from "./no_permission.vue?vue&type=script&lang=js"
export * from "./no_permission.vue?vue&type=script&lang=js"
import style0 from "./no_permission.vue?vue&type=style&index=0&id=aedafab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedafab8",
  null
  
)

export default component.exports